// extracted by css-extract-rspack-plugin
export default {"Dialog":"CheckStatusDialog-module__Dialog__jmz4T","Dialog_Body":"CheckStatusDialog-module__Dialog_Body__Hzf6u","Box":"CheckStatusDialog-module__Box__PJl9j"};